import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.notice');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-notice',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.notice/view.scss */
/* src/app/page.notice/view.scss: no such file or directory */`],
})
export class PageNoticeComponent implements OnInit, DoCheck {

    public item: any = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        this.item = WizRoute.segment.item;
        await this.service.render();
    }

    public async ngDoCheck() {
        this.item = WizRoute.segment.item;
    }
}

export default PageNoticeComponent;